import { Position } from '@deck.gl/core/typed/types/layer-props';
import { PlannerPoi, Visibility } from 'components/common/types/Planner.types';
import { Asset } from 'components/common/types/Asset.types';

export interface CoordinateLongitudeLatitude {
  latitude: number;
  longitude: number;
}

export interface POICluster {
  centerCoordinates: CoordinateLongitudeLatitude;
  pois: PlannerPoi[];
  boundingRadius: number;
  name: string;
  visibility: Visibility;
}

export interface AssetsInRangeResult {
  clusterIndex: number;
  assets: Asset[];
  poisInRange: PlannerPoi[];
}

export const positionToCoordinate = (position: Position): CoordinateLongitudeLatitude => ({
  longitude: position[0],
  latitude: position[1],
});

export const coordinateToPosition = (coordinate: CoordinateLongitudeLatitude): Position => {
  return [coordinate.longitude, coordinate.latitude];
};
